import { Button, ButtonGroup } from "react-bootstrap";

import { PAGE_SIZE } from "../../../constants";

export const NoPerPageButton = ({
	pageSize,
	number,
	active = pageSize === number,
	setPageSize,
	setInitPageSize,
}) => {
	return (
		<Button
			active={active}
			variant="outline-dark"
			size="sm"
			onClick={() => {
				setPageSize(number);
				setInitPageSize(number);
				localStorage.setItem(PAGE_SIZE, number);
			}}
		>
			{number}
		</Button>
	);
};

export const NoPerPageRibbon = ({ pageSize, setPageSize, setInitPageSize }) => {
	return (
		<ButtonGroup data-testid="test-paginationRibbon" className="ms-2">
			{[20, 30, 50, 100].map((choicePageSize) => (
				<NoPerPageButton
					key={choicePageSize}
					number={choicePageSize}
					pageSize={pageSize}
					setInitPageSize={setInitPageSize}
					setPageSize={setPageSize}
				/>
			))}
		</ButtonGroup>
	);
};

